export default "__VITE_ASSET__$lwiiZgr__"